import React, { useContext } from 'react';
import { Typography, Row, Col, Card, Divider } from 'antd';
import { ViewDocument } from '../../../../components';
import { Context } from '../../../../defaults';
import * as Questions from './types';



const { Title } = Typography;

const Question = ({ data, setData, student, current }) => {
    const { dictionary, language } = useContext(Context);
    const Question = Questions[`Question${data.question.questionTypeId}`];

    console.log(data.question.questionTypeId);
    return (
        <div>
            {
                data.question.questionText &&
                <Row gutter={16} style={{ marginBottom: 50 }}>
                    <Col>
                        <Title level={3}>{data.question.questionText}</Title>
                    </Col>
                </Row>
            }
            {
                data.question.files &&
                <div style={{ marginBottom: 50 }}>
                    <ViewDocument files={data.question.files} />
                </div>
            }
            {
                data.question.questionHtml &&
                <Row gutter={16} style={{ marginBottom: 50 }}>
                    <Col>
                        <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: data.question.questionHtml }} />
                    </Col>
                </Row>
            }

            <Divider orientation='center'>{dictionary?.Answer[language]}</Divider>

            {
                data.question.questionTypeId &&
                <Question data={data} setData={setData} current={current} />
            }
        </div >
    );
}

export default Question;